import { AuthStatus, PractitionerStatus, PractitionerStatusEnum } from "../generated/graphql";

/**
 * Combined access status shown to admins. Derived from the practitioner
 * status (admin kill-switch) and the user's credential state (authStatus):
 * a deactivated profile wins over any credential state.
 */
export const ACCESS_STATUS = {
  Active: "ACTIVE",
  Blocked: "BLOCKED",
  OtpPending: "OTP_PENDING",
  NoAccess: "NO_ACCESS",
  Deactivated: "DEACTIVATED",
} as const;

export type AccessStatus = (typeof ACCESS_STATUS)[keyof typeof ACCESS_STATUS];

export const getAccessStatus = (
  practitionerStatus: PractitionerStatus | PractitionerStatusEnum | null | undefined,
  authStatus: AuthStatus | null | undefined
): AccessStatus => {
  if (practitionerStatus === PractitionerStatusEnum.Inactive) {
    return ACCESS_STATUS.Deactivated;
  }
  switch (authStatus) {
    case AuthStatus.Blocked:
      return ACCESS_STATUS.Blocked;
    case AuthStatus.CredentialsSet:
      return ACCESS_STATUS.Active;
    case AuthStatus.ValidationCodePending:
      return ACCESS_STATUS.OtpPending;
    default:
      return ACCESS_STATUS.NoAccess;
  }
};
